import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AsyncNotNullPipe } from '@new/common/pipes/async-not-null.pipe';
import { requestStateSuccess } from '@new/common/utils/remote-data-utils';
import { isDefined } from '@new/common/utils/type-guards/is-defined';
import { TranslateModule } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { PoolFormState } from '../../state/pool-details/form/pool-form.state';

@Component({
  templateUrl: './pool-edit.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'container content' },
  standalone: true,
  imports: [TranslateModule, AsyncNotNullPipe, RouterModule, CommonModule]
})
export class PoolEditComponent {
  public poolName$: Observable<string>;
  public failure$: Observable<boolean>;

  constructor(private store: Store) {
    this.failure$ = this.store.select(PoolFormState.poolFailure);
    this.poolName$ = this.store.select(PoolFormState.pool).pipe(
      filter(requestStateSuccess),
      map(({ data }) => data?.name),
      filter(isDefined)
    );
  }
}
